import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v("Supplier prices")]), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-top-buttons"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openScriptsWithSupplierPrices();
      }
    }
  }, [_c(VIcon, {
    staticClass: "--margin-right",
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("fas fa-sync")]), _vm._v(" Updates according to supplier prices ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.importSupplierPrices();
      }
    }
  }, [_c(VIcon, {
    staticClass: "--margin-right",
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("fas fa-file-upload")]), _vm._v(" Import supplier prices ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openDeletePrices();
      }
    }
  }, [_c(VIcon, {
    staticClass: "--margin-right",
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("fas fa-wrench")]), _vm._v(" Manage suppliers ")], 1)], 1), [_c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      "hide-details": "auto",
      placeholder: "Search for a description...",
      "append-icon": "fa-search",
      disabled: _vm.isLoadingList,
      clearable: ""
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.formSearch.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.label,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "label", $$v);
      },
      expression: "formSearch.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      solo: "",
      "hide-details": "auto",
      items: _vm.pagingLimitsChoices,
      disabled: _vm.isLoadingList
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", [_c(VAutocomplete, {
    attrs: {
      solo: "",
      disabled: _vm.suppliers.length === 0 || _vm.isLoadingList,
      items: _vm.suppliers,
      label: "Supplier",
      "hide-details": "auto",
      "item-text": "display_name",
      "item-value": "id",
      "hide-no-data": "",
      clearable: "",
      multiple: "",
      chips: ""
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.suppliersIds != _vm.searchSuppliersIdsLastUsed && _vm.search();
      }
    },
    model: {
      value: _vm.formSearch.suppliersIds,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "suppliersIds", $$v);
      },
      expression: "formSearch.suppliersIds"
    }
  }), _c(VAutocomplete, {
    attrs: {
      solo: "",
      disabled: _vm.vintages.length === 0 || _vm.isLoadingList,
      items: _vm.vintages,
      label: "Vintage",
      "hide-details": "auto",
      "hide-no-data": "",
      clearable: "",
      multiple: "",
      chips: ""
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.vintages != _vm.searchVintagesLastUsed && _vm.search();
      }
    },
    model: {
      value: _vm.formSearch.vintages,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "vintages", $$v);
      },
      expression: "formSearch.vintages"
    }
  }), _c(VAutocomplete, {
    attrs: {
      solo: "",
      disabled: _vm.bottlings.length === 0 || _vm.isLoadingList,
      items: _vm.bottlings,
      label: "Bottling",
      "hide-details": "auto",
      "hide-no-data": "",
      clearable: "",
      multiple: "",
      chips: ""
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.bottlings != _vm.searchBottlingsLastUsed && _vm.search();
      }
    },
    model: {
      value: _vm.formSearch.bottlings,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "bottlings", $$v);
      },
      expression: "formSearch.bottlings"
    }
  })], 1), _c("div", {
    staticClass: "search-other-fields"
  }, [_c(VAutocomplete, {
    attrs: {
      solo: "",
      disabled: _vm.isLoadingList,
      items: _vm.status.options,
      "item-value": "id",
      "item-text": "name",
      label: "Filter by status",
      "hide-details": "auto",
      "hide-no-data": "",
      clearable: ""
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.selectedStatus != _vm.searchStatusLastUsed && _vm.search();
      }
    },
    model: {
      value: _vm.formSearch.selectedStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "selectedStatus", $$v);
      },
      expression: "formSearch.selectedStatus"
    }
  })], 1)])]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.formSearch.paging.currentPage,
      limits: Number(_vm.formSearch.paging.limits),
      totalNumber: _vm.totalNumber
    }
  })], 1)])]], 2), [_c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --no-hover",
    attrs: {
      headers: _vm.datatable_headers,
      items: _vm.datatable_items,
      "item-key": "id",
      "items-per-page": +_vm.formSearch.paging.limits,
      loading: _vm.isLoadingList,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.status",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("svg", {
          staticClass: "icon icon-xxs dot",
          class: ["fill-".concat(item.statusLabel)],
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "512",
            height: "512",
            viewBox: "0 0 512 512"
          }
        }, [_c("circle", {
          attrs: {
            cx: "256",
            cy: "256",
            r: "256"
          }
        })]), _c("span", {
          staticClass: "ml-2"
        }, [_vm._v(_vm._s(item.wineId == null ? "Not linked" : ""))])];
      }
    }, {
      key: "item.name",
      fn: function fn(_ref2) {
        var _item$nameForProductL;
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.name) + " "), item.wineId ? [_c("router-link", {
          staticClass: "router-link ml-2",
          attrs: {
            to: _vm.toProductDetails(item),
            target: "_blank"
          }
        }, [_c("i", {
          staticClass: "fas fa-external-link-alt"
        })])] : _vm._e(), !item.wineId && ((_item$nameForProductL = item.nameForProductLink) === null || _item$nameForProductL === void 0 ? void 0 : _item$nameForProductL.length) > 0 ? _c("div", {
          staticClass: "text-smaller"
        }, [_vm._v(" Failed link : " + _vm._s(item.nameForProductLink) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.price",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s("".concat(item.price, " \u20AC")) + " ")];
      }
    }, {
      key: "item.bottling",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s("".concat(item.bottling, "ml")) + " ")];
      }
    }, {
      key: "item.vintage",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(item.vintage ? item.vintage : "-") + " ")];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.createdAt)) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c("div", {
          staticClass: "my-2 flex gap-2"
        }, [item.wineId == null ? _c(VBtn, {
          staticClass: "dfwa-btn --small-2 highlight",
          attrs: {
            rounded: "",
            disabled: _vm.isLoadingList
          },
          on: {
            click: function click($event) {
              return _vm.openAssociateWineModal(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fa fa-link mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Attach to existing wine ")], 1) : _vm._e(), item.wineId == null ? _c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            rounded: "",
            disabled: _vm.isLoadingList
          },
          on: {
            click: function click($event) {
              return _vm.openCreateWineDialog(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fa fa-plus mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Create Wine ")], 1) : _vm._e(), item.statusLabel == "success" ? _c("span", [_vm._v("-")]) : _vm._e()], 1)];
      }
    }], null, true)
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("Paging", {
    attrs: {
      numberOfPages: _vm.numberOfPages,
      currentPage: +_vm.formSearch.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.formSearch.paging.currentPage,
      limits: +_vm.formSearch.paging.limits,
      totalNumber: _vm.totalNumber
    }
  })], 1)])]) : _vm._e()], _vm.isImportSupplierPricesShown ? _c("ImportSupplierPrices", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    model: {
      value: _vm.isImportSupplierPricesShown,
      callback: function callback($$v) {
        _vm.isImportSupplierPricesShown = $$v;
      },
      expression: "isImportSupplierPricesShown"
    }
  }) : _vm._e(), _vm.isScriptsWithSupplierPricesShown ? _c("ScriptWithSupplierPricesModal", {
    ref: "refScriptWithSupplierPricesModal",
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      scriptExecuted: function scriptExecuted($event) {
        return _vm.fetchSuppliers();
      },
      closed: function closed($event) {
        _vm.isScriptsWithSupplierPricesShown = false;
      }
    }
  }) : _vm._e(), _vm.createWineModal.isVisible ? _c("NewWineDialog", {
    attrs: {
      shown: _vm.createWineModal.isVisible,
      loggedUserData: _vm.loggedUserData,
      supplierPrice: _vm.createWineModal.selectedSupplierPrice,
      wineForCloning: {
        wineIdForCloning: _vm.wineIdForCloning,
        wine: _vm.associateWine.selectedSupplierPrice
      }
    },
    on: {
      close: _vm.closeCreateWineDialog,
      savedForSupplier: _vm.createWineSavedDialog
    }
  }) : _vm._e(), _vm.datatable_items.length > 0 ? _c("AssociateWineModal", {
    ref: "associateWineModal",
    attrs: {
      wineFiltersStorageKey: "supplierPricesListAssociateWines",
      loggedUserData: _vm.loggedUserData,
      modal: {
        title: "Associate wine - ".concat(_vm.associateWine.selectedSupplierPrice.name, " - ").concat(_vm.associateWine.selectedSupplierPrice.price, "\u20AC")
      },
      wine: {
        wineSupplierPrice: _vm.associateWine.selectedSupplierPrice
      },
      filtersVisibility: {
        showStockOnly: false,
        showWarehouseOnly: false,
        showSpecialDealsOnly: false,
        showDepartureContinent: false,
        showStockQuantityMin: false
      },
      wineCard: {
        displaySkuInsteadOfPrice: true
      },
      thirdPartyUserSelector: {
        display: false
      }
    },
    on: {
      associateWine: _vm.associateWineToSupplierPrice,
      associateCloneWine: _vm.associateCloneWine
    }
  }) : _vm._e(), _c("SupplierListModal", {
    ref: "SupplierListModal"
  }), _c("Confirm", {
    ref: "confirm"
  })], 2) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };